import { Box, Button, useTheme } from "@mui/material";
import { boxShadow, white } from "../../../theme/colours";

const ReBox = ({
  children,
  disabled,
  style,
  button,
  clickHandler,
  divProps,
}) => {
  const theme = useTheme();

  const containerStyle = {
    position: "relative",
    padding: "3%",
    borderRadius: "0.5rem",
    background: theme.palette.mode === "light" ? white : "#2B0060",
    boxShadow: theme.palette.mode === "light" && `0px 10px 15px ${boxShadow}`,
    opacity: disabled ? "50%" : "100%",
  };
  const buttonStyle = {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    borderRadius: "inherit",
  };

  return (
    <Box sx={{ ...containerStyle, ...style }} {...divProps}>
      {button && (
        <Button sx={buttonStyle} onClick={clickHandler} disabled={disabled} />
      )}
      {children}
    </Box>
  );
};

export default ReBox;
